<template>
  <div class="list-page-shell">
    <div class="list-page-stack">
      <section v-if="$slots.header" class="list-page-header">
        <slot name="header" />
      </section>

      <section v-if="$slots.filters" class="list-page-filters">
        <slot name="filters" />
      </section>

      <section class="list-page-content">
        <slot />
      </section>
    </div>
  </div>
</template>
